"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellPopover = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
function CellPopover(_a) {
    var cellRef = _a.cellRef, children = _a.children, onClose = _a.onClose;
    var popoverRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    // click outside should close the popover
    (0, core_ui_1.useOnClickOutside)(containerRef, function (e) {
        onClose(e);
    });
    // pressing escape should close the popover too
    (0, core_ui_1.useKeyEvent)('Escape', function () {
        onClose();
    }, []);
    // we move the focus once the popover mounts, so user can press tab to navigate between inputs
    (0, react_1.useEffect)(function () {
        var _a, _b;
        (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        // double clicking the cell selects the entire text of every children
        // this clears up text selection when that happens
        (_b = window.getSelection()) === null || _b === void 0 ? void 0 : _b.removeAllRanges();
    }, []);
    var _b = (0, react_1.useState)({
        targetAnchor: 'topRight',
        anchor: 'topLeft',
    }), tetherProps = _b[0], setTetherProps = _b[1];
    // some calculations are done when there's no enough space on the screen to render the popover
    // in that case, we render it on the left side instead
    (0, react_1.useEffect)(function () {
        var _a;
        var rect = (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!rect) {
            return;
        }
        var bodyRect = document.body.getBoundingClientRect();
        // if popover size exceeds the available viewport, we move it to the left
        // subtracts 120 to have a bit of margin
        if (rect.right + rect.width > bodyRect.width - 120) {
            setTetherProps({
                anchor: 'topRight',
                targetAnchor: 'topLeft',
            });
        }
    }, [setTetherProps]);
    return (react_1.default.createElement("div", { ref: containerRef },
        react_1.default.createElement(core_ui_1.ModalPortalProvider, { elementRef: containerRef },
            react_1.default.createElement(core_ui_1.Tether, { targetRef: cellRef, targetAnchor: tetherProps.targetAnchor, anchor: tetherProps.anchor, zIndex: core_ui_1.zIndices.overlay },
                react_1.default.createElement(core_ui_1.PopoverAnimation, { isOpen: true, direction: "left" },
                    react_1.default.createElement(core_ui_1.Box, { border: 1, borderRadius: 6, boxShadow: "overlay", backgroundColor: "white", elementRef: popoverRef, style: {
                            minWidth: 300,
                        } },
                        react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column" }, children)))))));
}
exports.CellPopover = CellPopover;
